import I18n from "packs/i18n.js.erb"
import { Controller } from "stimulus"
import { Calendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import bootstrapPlugin from "@fullcalendar/bootstrap"
import ptBrLocale from "@fullcalendar/core/locales/pt-br"
import "@fortawesome/fontawesome-free/css/all.css"
import moment from 'moment'

export default class extends Controller {
  static targets = [ "calendarDiv" ]

  connect() {
    this.calendar = new Calendar(this.calendarDivTarget, {
      plugins: [ dayGridPlugin, interactionPlugin, bootstrapPlugin ],
      locales: [ ptBrLocale ],
      locale: I18n.t("calendar.locale"),
      customButtons: {
        newEventButton: {
          text: I18n.t("calendar.new_event"),
          click: this.createEvent.bind(this)
        }
      },
      headerToolbar: {
        start: "today prev,next",
        center: "title",
        end: "newEventButton"
      },
      buttonText: {
        today: I18n.t("calendar.today")
      },
      themeSystem: "bootstrap",
      eventColor: "#007bff",
      events: this.data.get("url").concat(".json"),
      eventDataTransform: this.transformEvent,
      editable: true,
      select: this.createEvent.bind(this),
      selectable: true,
      selectOverlap: false,
      eventDrop: this.updateEvent,
      eventResize: this.updateEvent
    })
    this.calendar.render()
  }

  transformEvent(eventData) {
    eventData.end = moment(eventData.end, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD")
    return eventData
  }

  createEvent(selectionInfo) {
    let url = this.data.get("url").concat("/new")

    if (selectionInfo.startStr && selectionInfo.endStr) {
      const start_date = selectionInfo.startStr
      const end_date = moment(selectionInfo.endStr, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD")
      url = url.concat("?start=", start_date, "&end=", end_date)
    }

    Turbolinks.visit(url)
  }

  updateEvent(eventInfo) {
    const { event, revert } = eventInfo
    const start_date = event.startStr
    const end_date = moment(event.endStr, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD")

    $.ajax({
      url: event.url.replace("/edit", "").concat(".json"),
      type: "PUT",
      data: { event: { start_date, end_date } },
      error: revert
    })
  }
}
